module.exports = __webpack_public_path__ + "static/media/investment_account.c462fd82.svg";